import '@fontsource-variable/inter/wght.css';
import '@fontsource-variable/inter/wght-italic.css';
import '@fontsource-variable/manrope/wght.css';
import './styles/main.scss';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import Alpine from 'alpinejs';
import Splide from '@splidejs/splide';
import slideshowModal from './modal/slideshow';
import youtubeModal from './modal/youtube';
import kioskMap from './map';
import navigation, { desktopNavigationItem, mobileNavigationItem } from './navigation';

declare global {
    interface Window {
        Alpine: typeof Alpine;
        Splide: typeof Splide;
    }
}

window.Alpine = Alpine;
window.Splide = Splide;

Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.data('navigation', navigation);
Alpine.data('desktopNavigationItem', desktopNavigationItem);
Alpine.data('mobileNavigationItem', mobileNavigationItem);
Alpine.data('youtubeModal', youtubeModal);
Alpine.data('carouselModal', slideshowModal);
Alpine.data('kioskMap', kioskMap);

Alpine.start();
